import React from 'react';

/**
 * TextAreaField component - handles textarea input type
 */
function TextAreaField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <textarea
            id={fieldId}
            value={value || ''}
            onChange={(e) => onChange(index, e.target.value)}
            rows={4}
            className="w-full px-3 py-2 bg-surface-2 text-content border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-amber placeholder:text-content-muted"
            placeholder={field.placeholder || ''}
        />
    );
}

export default TextAreaField;
